import { FB_CONFIG_KEYS } from '../firebase/remoteConfig';
import { ROUTES } from 'utils/constants/constants_routes';
import { useNavigate } from 'react-router-dom';
import useTestAB from 'hooks/utilities/useTestAB';

export const useCustomNavigation = () => {
  const navigate = useNavigate();
  const { variant } = useTestAB({
    testName: FB_CONFIG_KEYS.FIREBASE_TESTAB_TINK_A,
  });

  const onlineBankVerifyRoute =
    variant === 'variantA'
      ? ROUTES.FIRST_LOAN_ONLINE_BANK_VERIFY
      : ROUTES.FIRST_LOAN_ONLINE_BANK_VERIFY_NEW;

  const navigateToOnlineBankVerification = () =>
    navigate(onlineBankVerifyRoute);

  return {
    onlineBankVerifyRoute,
    navigateToOnlineBankVerification,
  };
};
